<template>
    <div :class="screenIndex===2?'page-nav c1':'page-nav'">
        <div>
            <img src="./img/logo.png" alt="" :class="screenIndex===2?'logo cur':'logo'" @click="logoFun">
            <img src="../../assets/images/3.png" alt="" v-if="screenIndex===2" class="corner-mark4">
        </div>
        <div :class="frameAnimated?'navs cur':'navs'">
            <a href="javascript:;" :class="slideShow?'nv hd':'nv'" @click="navKnowledgeSearch">知识检索</a>
            <a href="https://dhc.library.sh.cn/humanmap/" target="_blank" :class="slideShow?'nv hd':'nv'">人文地图</a>
            <a href="javascript:;" :class="slideShow?'nv hd':'nv'"
                @click="onRelation('http://data.library.sh.cn/entity/person/4lnpsgh342b2n1ru', null)"
            >关系图谱</a>
            <!-- <router-link to="/" :class="slideShow?'nv hd':'nv'">故事场景</router-link> -->
            <a-dropdown placement="bottomLeft">
                <!-- <a-button>故事场景</a-button> -->
                <a href="javascript:;" :class="slideShow?'nv hd':'nv'">故事场景</a>
                <template v-slot:overlay>
                    <a-menu>
                        <a-menu-item>
                            <a rel="noopener noreferrer" href="javascript:;"
                                @click="onRelation('http://data.library.sh.cn/entity/person/lfzuha6tvgzrh3wc', 'bk')"
                            >报人关系</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a target="_blank" rel="noopener noreferrer" 
                                href="https://dhc.library.sh.cn/bk/brandHome"
                            >海派品牌</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a target="_blank" rel="noopener noreferrer" 
                                href="https://dhc.library.sh.cn/newspapermap/"
                            >报馆地图</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a target="_blank" rel="noopener noreferrer" 
                                href="https://dhc.library.sh.cn/redtrip/index.html"
                            >红色旅游</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a target="_blank" rel="noopener noreferrer" 
                                href="http://wkl.library.sh.cn/"
                            >从武康路出发</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a target="_blank" rel="noopener noreferrer" 
                                href="https://ldy.library.sh.cn/"
                            >电影记忆</a>
                        </a-menu-item>
                        <!-- 20231128 高德水印问题 chenss <a-menu-item>
                            <a target="_blank" rel="noopener noreferrer" 
                                href="https://dhc.library.sh.cn/familytree/"
                            >家谱迁徙图</a>
                        </a-menu-item> -->
                    </a-menu>
                </template>
            </a-dropdown>
            <span :class="slideShow?'nv hd':'nv'" v-if="!userInfo">
                <a :href="Common.registerUrl">注册</a>/<a href="javascript:;" @click="login">登录</a>
            </span>
            <span :class="slideShow?'nv hd':'nv'" v-else> 
                <a href="javascript:;" @click="goDhcUc">
                    <img class="user" src="/user2.png">{{Common.userInfo.userName}}
                </a> |
                <a href="javascript:;" @click="exit">退出</a>
            </span>
            <a href="javascript:" :class="slideShow?'menu-toggle cur':'menu-toggle'" @click="showSlide">
                <span></span>
                <span></span>
                <span></span>
            </a>
        </div>
        <div :class="slideShow?'menu-slide-box cur':'menu-slide-box'">
            <div class="s-logo">
                <img src="../../assets/images/3.png" alt="" class="corner-mark2">
            </div>
            <div class="links">
                <div class="link-row">
                    <div class="title">
                        文<br/>献<br/>知<br/>识<br/>库
                    </div>
                    <div class="td">
                        <div class="swipe-box">
                            <swiper :options="swiperOptions" ref="mySwiper1">
                                <swiper-slide v-for="f in Math.ceil(swiperData1.length/3)" :key="f">
                                    <a v-for="item in (f===(Math.ceil(swiperData1.length/3))?(swiperData1.length%3===0?3:swiperData1.length%3):3)"
                                       :href="swiperData1[(f-1)*3+item-1].url" :key="item" target="_blank"
                                    >
                                        <span @mouseenter="handleHover($event,swiperData1[(f-1)*3+item-1])" @mouseleave="handleLeave">{{swiperData1[(f-1)*3+item-1].name}}</span>
                                    </a>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="more" v-if="swiperData1.length > 3">
                            <a-icon type="left" class="prev1" style="font-size: 20px;margin-right: 10px"></a-icon>
                            <a-icon type="right" class="next1" style="font-size: 20px;"></a-icon>
                        </div>
                    </div>
                </div>
                <div class="link-row">
                    <div class="title">
                        基<br/>础<br/>知<br/>识<br/>库
                    </div>
                    <div class="td">
                        <div class="swipe-box">
                            <swiper :options="swiperOptions2" ref="mySwiper2">
                                <swiper-slide v-for="f in Math.ceil(swiperData2.length/3)" :key="f">
                                    <a v-for="item in (f===(Math.ceil(swiperData2.length/3))?(swiperData2.length%3===0?3:swiperData2.length%3):3)"
                                       :href="swiperData2[(f-1)*3+item-1].url" :key="item" target="_blank"
                                    >
                                        <span @mouseenter="handleHover($event,swiperData2[(f-1)*3+item-1])" @mouseleave="handleLeave">{{swiperData2[(f-1)*3+item-1].name}}</span>
                                    </a>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="more" v-if="swiperData2.length > 3">
                            <a-icon type="left" class="prev2" style="font-size: 20px;margin-right: 10px"></a-icon>
                            <a-icon type="right" class="next2" style="font-size: 20px;"></a-icon>
                        </div>
                    </div>
                </div>
                <div class="link-row">
                    <div class="title">
                        本<br/>体<br/>词<br/>表
                    </div>
                    <div class="td">
                        <div class="swipe-box">
                            <swiper :options="swiperOptions3" ref="mySwiper3">
                                <swiper-slide v-for="f in Math.ceil(swiperData3.length/3)" :key="f">
                                    <a v-for="item in (f===(Math.ceil(swiperData3.length/3))?(swiperData3.length%3===0?3:swiperData3.length%3):3)"
                                       :href="swiperData3[(f-1)*3+item-1].url" :key="item" target="_blank"
                                    >
                                        <span @mouseenter="handleHover($event,swiperData3[(f-1)*3+item-1])" @mouseleave="handleLeave">{{swiperData3[(f-1)*3+item-1].name}}</span>
                                    </a>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="more" v-if="swiperData3.length > 3">
                            <a-icon type="left" class="prev3" style="font-size: 20px;margin-right: 10px"></a-icon>
                            <a-icon type="right" class="next3" style="font-size: 20px;"></a-icon>
                        </div>
                    </div>
                </div>
                <div class="link-row">
                    <div class="title">
                        工<br/>具
                    </div>
                    <div class="td">
                        <div class="swipe-box">
                            <swiper :options="swiperOptions4" ref="mySwiper4">
                                <swiper-slide v-for="f in Math.ceil(swiperData4.length/3)" :key="f">
                                    <a v-for="item in (f===(Math.ceil(swiperData4.length/3))?(swiperData4.length%3===0?3:swiperData4.length%3):3)"
                                       :href="swiperData4[(f-1)*3+item-1].url" :key="item" target="_blank"
                                       :style="swiperData4.length <= 3 ? 'width: 27%;' : ''"
                                    >
                                        <span @mouseenter="handleHover($event,swiperData4[(f-1)*3+item-1])" @mouseleave="handleLeave" v-html="swiperData4[(f-1)*3+item-1].name"></span>
                                    </a>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="more" v-if="swiperData4.length > 3">
                            <a-icon type="left" class="prev4" style="font-size: 20px;margin-right: 10px"></a-icon>
                            <a-icon type="right" class="next4" style="font-size: 20px;"></a-icon>
                        </div>
                    </div>
                </div>
                <div class="link-row"></div>
                <div class="link-row">
                    <div class="title">
                        其<br/>他<br/>文<br/>献
                    </div>
                    <div class="td">
                        <div class="swipe-box">
                            <swiper :options="swiperOptions5" ref="mySwiper5">
                                <swiper-slide v-for="f in Math.ceil(swiperData5.length/3)" :key="f">
                                    <a v-for="(item,index) in (f===(Math.ceil(swiperData5.length/3))?(swiperData5.length%3===0?3:swiperData5.length%3):3)"
                                       :href="swiperData5[(f-1)*3+item-1].url" :key="'mySwiper5'+index" target="_blank"
                                       :style="swiperData5.length <= 3 ? 'width: 27%;' : ''"
                                    >
                                        <!-- {{swiperData5[(f-1)*3+item-1].name}} -->
                                        <span v-if="!swiperData5[(f-1)*3+item-1].hoverEng" 
                                            v-html="swiperData5[(f-1)*3+item-1].name"
                                        ></span>
                                        <span v-else 
                                            @mouseenter="handleHover($event,swiperData5[(f-1)*3+item-1])" 
                                            @mouseleave="handleLeave" v-html="swiperData5[(f-1)*3+item-1].name"
                                        ></span>
                                    </a>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="more" v-if="swiperData5.length > 3">
                            <a-icon type="left" class="prev5" style="font-size: 20px;margin-right: 10px"></a-icon>
                            <a-icon type="right" class="next5" style="font-size: 20px;"></a-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="hover-tips" v-if="showHover && hoverTit" :style="'left:'+hoverX+'px;top:'+hoverY+'px'">
            <div class="tit">{{hoverTit}}</div>
            <p>{{hoverEng}}</p>
        </div>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    export default {
        components: {
            Swiper,
            SwiperSlide
        },
        directives: {
            swiper: directive
        },
        data(){
            return{
                logo1:'/pic/etl.png',
                tips:"/pic/tips.png",
                navKnowledge: 0,   // 导航栏知识检索
                slideShow:false,
                userInfo: null,
                showHover:false,
                hoverTit:'',
                hoverEng:'',
                hoverX:'',
                hoverY:'',
                progress1: 0,
                progress2: 0,
                progress3: 0,
                progress4: 0,
                progress5: 0,
                swiperOptions:{
                    slidesPerView: 'auto',
                    spaceBetween: 10, // 间距
                    freeMode: true,
                    observer:true,//修改swiper自己或子元素时，自动初始化swiper
                    observeParents:true,//修改swiper的父元素时，自动初始化swiper
                    navigation: {
                        nextEl: '.next1',
                        prevEl: '.prev1',
                        disabledClass: 'button-disabled'
                    }
                },
                swiperOptions2:{
                    slidesPerView: 'auto',
                    spaceBetween: 2, // 间距
                    freeMode: true,
                    observer:true,//修改swiper自己或子元素时，自动初始化swiper
                    observeParents:true,//修改swiper的父元素时，自动初始化swiper
                    navigation: {
                        nextEl: '.next2',
                        prevEl: '.prev2',
                        disabledClass: 'button-disabled'
                    }
                },
                swiperOptions3:{
                    slidesPerView: 'auto',
                    spaceBetween: 10, // 间距
                    freeMode: true,
                    navigation: {
                        nextEl: '.next3',
                        prevEl: '.prev3',
                        disabledClass: 'button-disabled'
                    }
                },
                swiperOptions4:{
                    slidesPerView: 'auto',
                    spaceBetween: 10, // 间距
                    freeMode: true,
                    navigation: {
                        nextEl: '.next4',
                        prevEl: '.prev4',
                        disabledClass: 'button-disabled'
                    }
                },
                swiperOptions5:{
                    slidesPerView: 'auto',
                    spaceBetween: 10, // 间距
                    freeMode: true,
                    navigation: {
                        nextEl: '.next5',
                        prevEl: '.prev5',
                        disabledClass: 'button-disabled'
                    }
                },
                swiperData1:[
                    {
                        name:'家谱',
                        id:'1',
                        hoverTit:'中国家谱知识服务平台',
                        hoverEng:'Chinese Genealogy Knowledge Service Platform',
                        url:'//jiapu.library.sh.cn'
                    },
                    {
                        name:'盛档',
                        id:'2',
                        hoverTit:'盛宣怀档案知识库',
                        hoverEng:'Sheng Xuanhuai Archives Knowledge Base',
                        url:'//sd.library.sh.cn'
                    },
                    {
                        name:'古籍',
                        id:'3',
                        hoverTit:'中文古籍联合目录及循证平台',
                        hoverEng:'Chinese Ancient Books Union Catalogue and Evidence-based Platform',
                        url:'//gj.library.sh.cn'
                    },
                    {
                        name:'红色文献',
                        id:'4',
                        hoverTit:'革命（红色）文献服务平台',
                        hoverEng:'Revolutionary(Red) Document Service Platform',
                        url:'//red.library.sh.cn'
                    }
                    // ,
                    // {
                    //     name:'舆图',
                    //     id:'5',
                    //     hoverTit:'',
                    //     hoverEng:'',
                    //     url:'//gj.library.sh.cn/yutu'
                    // }
                ],
                swiperData2:[
                    {
                        name:'人物',
                        id:'1',
                        hoverTit:'人名规范库',
                        hoverEng:'Name Authority Database',
                        url:'//names.library.sh.cn'
                    },
                    {
                        name:'姓氏',
                        id:'2',
                        hoverTit:'华人姓氏列表',
                        hoverEng:'Chinese Surname List',
                        url:'//data.library.sh.cn/familynames'
                    },
                    {
                        name:'地名',
                        id:'3',
                        hoverTit:'地理名词表',
                        hoverEng:'Geographic Names List',
                        url:'//data.library.sh.cn/place/main'
                    },
                    {
                        name:'机构',
                        id:'4',
                        hoverTit:'收藏机构名录',
                        hoverEng:'Organizations Directory',
                        url:'//data.library.sh.cn/organization/main'
                    },
                    {
                        name:'时间',
                        id:'5',
                        hoverTit:'中国历史纪年表',
                        hoverEng:'Chinese History Chronology',
                        url:'//data.library.sh.cn/dynasty/main'
                    },
                    {
                        name:'事件',
                        id:'6',
                        hoverTit:'历史文化事件',
                        hoverEng:'Cultural Events',
                        url:'//data.library.sh.cn/shnh/event/webapi/tolist'
                    },
                    {
                        name:'印章',
                        id:'7',
                        hoverTit:'印章知识库',
                        hoverEng:'Seal Knowledge Base',
                        url:'//data.library.sh.cn/gj/webapi/toSealList'
                    },
                    {
                        name:'建筑',
                        id:'8',
                        hoverTit:'建筑',
                        hoverEng:'Architectures',
                        url:'//data.library.sh.cn/shnh/wkl/webapi/building/toAllBuilding'
                    },
                ],
                swiperData3:[
                    {
                        name:'CBDB',
                        id:'1',
                        hoverTit:'CBDB本体',
                        hoverEng:'CBDB Ontology',
                        url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/cbdb'
                    },
                    {
                        name:'电影',
                        id:'2',
                        hoverTit:'上海年华本体',
                        hoverEng:'Shanghai Memory Ontology',
                        url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlmemo'
                    },
                    {
                        name:'档案',
                        id:'3',
                        hoverTit:'手稿及档案本体',
                        hoverEng:'Archive and Manuscripts Ontology',
                        url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlmarc'
                    },
                    {
                        name:'家谱',
                        id:'4',
                        hoverTit:'家谱本体',
                        hoverEng:'Genealogy Ontology',
                        url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlgen'
                    },
                    {
                        name:'古籍',
                        id:'5',
                        hoverTit:'古籍本体',
                        hoverEng:'Ancient book Ontology',
                        url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlancient'
                    },
                    {
                        name:'书目',
                        id:'6',
                        hoverTit:'关联书目数据本体词表',
                        hoverEng:'Linked Bibliographic Data Ontology Vocabulary',
                        url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlbib'
                    }
                ],
                swiperData4:[
                    {
                        name:'众包',
                        id:'1',
                        hoverTit:'历史文献众包平台',
                        hoverEng:'Historical Document Crowd-sourcing Platform',
                        url:'http://zb.library.sh.cn/'
                    },
                   
                    {
                        name:'家谱联编',
                        id:'2',
                        hoverTit:'家谱联合编目系统',
                        hoverEng:'Chinese Genealogy Union Cataloging System',
                        url:'http://jplb.library.sh.cn/'
                    },
                    // {
                    //     name:'&nbsp;ETL',
                    //     id:'2',
                    //     hoverTit:'ETL（Any2RDF）',
                    //     hoverEng:'',
                    //     url:'http://data.library.sh.cn/mrdsj/index.html'
                    // }
                    {
                        name:'文本分析',
                        id:'3',
                        hoverTit:'文本分析工具包平台',
                        hoverEng:'',
                        url:'https://tools.library.sh.cn'
                    },
                    {
                        name:'HGIS',
                        id:'4',
                        hoverTit:'HGIS支撑平台',
                        hoverEng:'',
                        url:'https://hgis.library.sh.cn'
                    }
                    ,
                    {
                        name:'SNS',
                        id:'5',
                        hoverTit:'SNS分析平台',
                        hoverEng:'',
                        url:'https://sns.library.sh.cn'
                    }
                ],
                swiperData5:[
                    {
                        name:'报刊',
                        id:'1',
                        hoverTit:'近代报刊资源库',
                        hoverEng:'',
                        url:'https://dhc.library.sh.cn/bk/home'
                    },
                    {
                        name:'近代图书',
                        id:'2',
                        hoverTit:'中国近代图书全文数据库',
                        hoverEng:'Books of Modern China (1840~1949)',
                        url:'//jdts.library.sh.cn'
                    }
                ]
            }
        },
        props:{
            frameAnimated:{
                required: true
            },
            screenIndex:{
                required: true
            }
        },
        created(){
            this.loggingStatus();
        },
        mounted() {
            // this.getAccount(); // 获取登录状态并获取用户信息
            this.$nextTick(()=>{
            })
        },
        methods:{
            logoFun(){
                if(this.screenIndex === 2) this.$emit('logoFun');
            },
            goDhcUc(){ // 登陆后,点击用户名跳转页面
                let token = this.getTokenFunc();  // 获取token
                // window.location.href = "https://dhc.library.sh.cn/uc/?token=" + token;
                // window.open("https://dhc.library.sh.cn/uc/?token=" + token);
                window.open("https://dhc.library.sh.cn/user?token=" + token);
            },
            navKnowledgeSearch(){ // 导航栏知识检索
                this.$emit('navKnowledgeSearch')
            },
            showSlide(){
                this.slideShow=!this.slideShow
                this.$emit('hideContent')
            },
            login(){ // 登录
                this.goLogin(this.Common.authorizeUrl);
            },
            exit(){
                this.isExit();
            },
            loggingStatus(){ // 登录状态
                let token = this.getTokenFunc();  // 获取token
                this.getAccount(token); // 获取用户信息
            },
            handleHover(e,item){
                this.showHover = true
                this.hoverTit = item.hoverTit
                this.hoverEng = item.hoverEng
                this.hoverX = e.clientX-100
                this.hoverY = e.clientY+40
            },
            handleLeave(){
                this.showHover = false
            }
        }
    }
</script>

<style lang="less" scoped>
.ant-dropdown-menu{
  background: rgba(48, 48, 99, 0.9) !important;
  a{
    color: #fff!important;
  }
}
</style>